<script setup>
    import { ref, onMounted } from 'vue'
    import { useRouter, useRoute } from 'vue-router'
    import insightsRecruitInfoService from "../../services/insights/insightsRecruitInfoService";
    import {usePageLoadingStore} from "../../../../stores/pageLoading";

    const loadingStore = usePageLoadingStore()

    const router = useRouter();
    const route = useRoute();

    const recruitInfoDetail = ref({
        boardId: route.params.id || '',
        title: '',
        notifyYn: 'N',
        content: '',
        answer: '',
        createDate: null,
        modifyDate: null,
        hitCount: 0,
        attachList: [],
    });

    onMounted(() => {
        retrieveRecruitInfoDetail();
    })

    const retrieveRecruitInfoDetail = () => {
        const { boardId } = recruitInfoDetail.value;
        if(!boardId) {
            router.push({name: 'InsightsRecruitInfo'})
            return false;
        }
        loadingStore.loading = true;
        insightsRecruitInfoService.retrieveRecruitInfoDetail(boardId)
            .then( (res) => {
                loadingStore.loading = false;
                if(res.data.code.toLowerCase() === 'success') {
                    const result = res.data.result;
                    recruitInfoDetail.value = result;
                }
            }).catch( (error) =>  {
            loadingStore.loading = false;
            console.log(error);
        });
    }
</script>

<template>
    <div class="container">
        <div class="inner">
            <div class="title page-title">
                <h3>채용정보</h3>
            </div>
            <div class="board-detail">
                <div class="header">
                    <div class="board-title">
                        <p v-if="recruitInfoDetail.notifyYn === 'Y'">{{recruitInfoDetail.title }}📣<img v-if="recruitInfoDetail.attachList.length > 0 && recruitInfoDetail.attachList[0].fileName" src="/src/assets/images/icon-file.png" /></p>
                        <p v-else>{{ recruitInfoDetail.title }}<img v-if="recruitInfoDetail.attachList.length > 0 && recruitInfoDetail.attachList[0].fileName" src="/src/assets/images/icon-file.png" /></p>
                    </div>
                    <span>작성일 <i>{{ $yyyymmddOrHHmm(recruitInfoDetail.createDate) }}</i></span>
                    <span>조회수 <i>{{ $number(recruitInfoDetail.hitCount) }}</i></span>
                </div>
                <div class="body">
                    <div class="text" v-html="recruitInfoDetail.content"></div>
                </div>
                <div class="control">
                    <dl class="download" v-if="recruitInfoDetail.attachList.length > 0 && recruitInfoDetail.attachList[0].fileName">
                        <dt>첨부</dt>
                        <dd>
                            <div v-for="attach in recruitInfoDetail.attachList">
                                {{ attach.fileName }}
                                <KSATextButton v-if="attach.fileDir" class="ml-xs" text="다운로드" @click="$download(attach.fileDir)" />
                            </div>
                        </dd>
                    </dl>
                    <div v-if="recruitInfoDetail.prevBoard && recruitInfoDetail.prevBoard.boardId">이전글<RouterLink :to="{name:'InsightsRecruitInfoDetail', params:{id: recruitInfoDetail.prevBoard.boardId}}"><span>{{ recruitInfoDetail.prevBoard.title }}</span></RouterLink></div>
                    <div v-if="recruitInfoDetail.nextBoard && recruitInfoDetail.nextBoard.boardId">다음글<RouterLink :to="{name:'InsightsRecruitInfoDetail', params:{id: recruitInfoDetail.nextBoard.boardId}}"><span>{{ recruitInfoDetail.nextBoard.title }}</span></RouterLink></div>
                </div>
            </div>
            <div class="btn-wrap text-left">
                <KSASecondaryButton class="gray_button" text="목록" @click="router.push({name: 'InsightsRecruitInfo'})" />
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    img {
        width: 14px;
        vertical-align: middle;
        margin: 0 0 0 4px;
    }
    .board-detail .body .text {
      overflow: hidden;
    }
</style>
